import React from 'react'

function Home() {
  return (
    <h1>Premix!</h1>  
  )
}

export default Home;